import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {dishesService} from "../../../services/dishes-services";


const initialState = {
    dishesArray: [],
    dishesFiltered: [],
    searchActive: false,
    dishesA: [],
    singleDish: {},
    filterParams: {
        word: ''
    },
    status: null,
    error: null,
    trigger: 0,
}


const getAllDishes = createAsyncThunk(
    'dishesSlice/getAllDishes',
    async (_, {rejectWithValue}) => {
        try {
            return await dishesService.getAllDishes();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const getAllDishesPaginated = createAsyncThunk(
    'dishesSlice/getAllDishesPaginated',
    async ({page, word}, {rejectWithValue}) => {
        try {
            return await dishesService.getAllDishesPaginated({page, word});
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const getDishById = createAsyncThunk(
    'dishesSlice/getDishById',
    async ({id}, {rejectWithValue}) => {
        try {
            return await dishesService.getDishById(id);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const dishesSlice = createSlice({
        name: "dishesSlice",
        initialState,
        reducers: {
            changeTrigger: (state, action) => {
                state.trigger = state.trigger + 1;
            },
            setFilterParams: (state, action) => {
                state.filterParams = {
                    ...state.filterParams,
                    ...action.payload
                };
            },
            clearFilters: (state) => {
                state.filterParams = {
                    word: ''
                };
            },
            filteredDishes: (state, action) => {
                const name = action.payload?.toLowerCase().trim();
                if (name) {
                    state.searchActive = true;
                    state.dishesFiltered = state.dishesArray.filter((obj) =>
                        obj.name?.en?.toLowerCase().includes(name) ||
                        obj.name?.ru?.toLowerCase().includes(name) ||
                        obj.name?.ge?.toLowerCase().includes(name)
                    );
                } else {
                    state.searchActive = false;
                    state.dishesFiltered = [];
                }
            },
            clearSearch: (state) => {
                state.searchActive = false;
                state.dishesFiltered = [];
            },
        },
        extraReducers: builder =>
            builder
                .addCase(getAllDishes.pending, state => {
                    state.status = 'Loading';
                    state.error = null;
                })
                .addCase(getAllDishes.fulfilled, (state, action) => {
                    state.status = 'fulfilled';
                    state.dishesArray = action.payload;
                })
                .addCase(getAllDishes.rejected, (state, action) => {
                    state.status = 'rejected';
                    state.error = action.payload;
                })
                .addCase(getAllDishesPaginated.pending, state => {
                    state.status = 'Loading';
                    state.error = null;
                })
                .addCase(getAllDishesPaginated.fulfilled, (state, action) => {
                    state.status = 'fulfilled';
                    state.dishesA = action.payload;
                })
                .addCase(getAllDishesPaginated.rejected, (state, action) => {
                    state.status = 'rejected';
                    state.error = action.payload;
                })
                .addCase(getDishById.pending, (state) => {
                    state.status = "loading";
                    state.error = null;
                })
                .addCase(getDishById.fulfilled, (state, action) => {
                    state.status = "fulfilled";
                    state.singleDish = action.payload;
                })
                .addCase(getDishById.rejected, (state, action) => {
                    state.status = "rejected";
                    state.error = action.payload;
                })
    }
);

const {reducer: dishesReducer, actions} = dishesSlice;
const dishesActions = {
    ...actions,
    getAllDishes,
    getAllDishesPaginated,
    getDishById
}

export {
    dishesReducer,
    dishesActions,
}